import { BaseModel } from 'app/core/_base/crud';
export class ChonDoiTuongTHCPModel extends BaseModel {
        Job_Id: number
        JobCode: string
        JobName: string
        JobType:string
        isSelected:boolean
        clear() {
                this.Job_Id=0;
                this.JobCode='';
                this.JobName='';
                this.JobType='';
                this.isSelected=false;
        }
        copy(item: ChonDoiTuongTHCPModel) {
                this.Job_Id=item.Job_Id;
                this.JobCode=item.JobCode;
                this.JobName=item.JobName
                this.JobType=item.JobType;
                this.isSelected=item.isSelected;
        }
}
